package com.eladfinish.bible.contest.screens.chapterComplete.features.progressiveExposure

import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.CompleteType

class ExposureStepReducer(
    private val renderer: ExposureTextRenderer,
) {

    private val strategies: Map<CompleteType, ExposureStepStrategy> =
        mapOf(
            CompleteType.NEXT_EXPOSURE_VERSE to VerseExposureStrategy(),
            CompleteType.NEXT_EXPOSURE_HALF to HalfExposureStrategy(),
            CompleteType.NEXT_EXPOSURE_WORD to WordExposureStrategy(),
        )

    fun reduce(
        state: ProgressiveExposureState,
        completeType: CompleteType,
    ): ProgressiveExposureState {
        if (state.isFinished()) return state

        val strategy = strategies[completeType] ?: return state

        return strategy.apply(
            context = ExposureStepContext(
                state = state,
                renderer = renderer,
            ),
        )
    }
}
